import axios from 'axios'

const base = '/v2/portal'

export default {
    getPlantedAudit(icareId){
        return axios.get(base + '/icare/' + icareId + '/planted-audit')
            .then(response => {
                return response.data
            })
    },
}
